import { Component, uiEvent } from "@kluntje/core";
import { toggleClass, hasClass } from "@kluntje/js-utils/lib/dom-helpers";
import { ACTIVE } from "Constants/cssClasses";
import { CHANGED_EVENT } from "Constants/eventTypes";

export class Toggle extends Component {
  get isDisabled(): boolean {
    return this.hasAttribute("disabled") && this.getAttribute("disabled") !== "false";
  }

  get active(): boolean {
    return hasClass(this, ACTIVE);
  }

  set active(newActiveState: boolean) {
    if (this.active === newActiveState) return;
    toggleClass(this, ACTIVE, newActiveState);
    this.dispatchEvent(
      new CustomEvent(CHANGED_EVENT, {
        detail: {
          target: this,
        },
      }),
    );
  }

  silentStateChange(newActiveState: boolean) {
    toggleClass(this, ACTIVE, newActiveState);
  }

  @uiEvent("this", "click")
  toggleState() {
    this.active = !this.active;
  }
}

customElements.define("wec-e-toggle", Toggle);
